<template>
  <template v-if="editionMode">
    <SelectComponent
      v-model="selectedValues"
      :values="orderedItemCategories"
      :label="$t('global.categories')"
      :required="required"
      :alphabetical-order="!useCustomOrder"
      name=""
      display-key="name_index"
    />
    <div v-if="errors && errors.length" class="form-help text-red-600">
      <div v-for="(error, index) in errors" :key="index">
        {{ $t(error, { attribute: $t('global.categories') }) }}
      </div>
    </div>
  </template>
  <BaseShowLabel
    v-else
    :label="$t('global.categories')"
    :model-value="selectedLabel"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'
import BaseShowLabel from '@c/addf-package/components/BaseLabel/BaseShowLabel.vue'

export default {
  name: 'SelectItemCategory',
  components: { BaseShowLabel, SelectComponent },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number],
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    funeralHomeId: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters({
      itemCategories: 'metadata/getMetadataItemCategoriesSelect',
      funeralHomeSettings: 'metadata/getFuneralHomeSettings'
    }),
    useCustomOrder() {
      if (!this.funeralHomeId || !this.funeralHomeSettings) {
        return false
      }
      return !!this.funeralHomeSettings[this.funeralHomeId]?.item_category_custom_order
    },
    orderedItemCategories() {
      const rootCategories = this.itemCategories.filter(
        (itemCategory) => itemCategory.parent_id === null
      )
      if (this.useCustomOrder) {
        return [...rootCategories].sort((a, b) => {
          if (a.position === null && b.position === null) {
            return a.name_index.localeCompare(b.name_index)
          }
          if (a.position === null) return 1
          if (b.position === null) return -1
          return a.position - b.position
        })
      }
      return [...rootCategories].sort((a, b) => a.name_index.localeCompare(b.name_index))
    },
    selectedLabel() {
      return this.itemCategories.find(
        (itemCategory) => itemCategory.id === this.modelValue
      )?.name_index
    }
  }
}
</script>
